export enum HeliosUserPermissions {
  OptometristRxEntryQuickActions = 'optometrist.rx_entry_quick_actions',
}
